export default function StatsApi({ makeRequest, buildRequest, baseUrl = '' }) {
    
    function getStatus() {
        return buildRequest().then(instance => makeRequest(instance.get('/status')));
    }

    function getCentreBankingStats() {
        return buildRequest().then(instance => makeRequest(instance.get(`${baseUrl}/status/centreBanking`)));
    }

    return {
        getStatus,
        getCentreBankingStats
    }

}